import axios, { Axios } from 'axios'
import { createStore } from './util'
import { notify } from '@/utils'
import Bowser from 'bowser'
import { links } from '../app/links'
import { useUser } from './user'

interface AppStore {
  http: Axios
  mode: 'light' | 'dark'
  page: string | null
  ip: string | null
  browserName: string | null

  setMode: (mode: 'light' | 'dark') => void
  setPage: (page: string) => void
  clearPage: () => void
  getIp: () => void
  getBrowserName: () => void
}

export const useApp = createStore<AppStore>(
  'app',
  (set) => {
    const appEnvironment = import.meta.env.APP_ENVIRONMENT

    const isDev = appEnvironment !== 'staging' && appEnvironment !== 'production'

    // default validator-api url is http://localhost:3031
    const baseURL: string =
      process.env.VITE_API_URL || (isDev ? 'http://localhost:3031' : 'https://ext-api.dawn.money')
    const http = axios.create({ baseURL })

    http.interceptors.response.use(
      (response) => response,
      (error) => {
        const { token } = useUser.getState()
        if (error.response && error.response.status === 401 && token) {
          console.log('Invalid token, redirecting to login.')
          useUser.getState().clearToken()
          window.location.href = links.login.root
        }
        return Promise.reject(error)
      },
    )

    return {
      http,
      mode: 'light',
      page: null,
      ip: null,
      browserName: null,
      getIp: async () => {
        try {
          const response = await http.get<{ ip: string }>('https://api.ipify.org?format=json')
          console.log('ip: ' + response.data.ip)
          set({ ip: response.data.ip })
        } catch {
          notify.error('Failed get IP')
          set({ ip: null })
        }
      },
      getBrowserName: () => {
        const browser = Bowser.getParser(window.navigator.userAgent)
        console.log('browserName: ' + browser.getBrowserName())
        set({ browserName: browser.getBrowserName() })
      },
      setMode: (mode) => {
        document.documentElement.setAttribute('data-color-scheme', mode)
        set({ mode })
      },
      setPage: (page: string) => {
        set({ page })
      },
      clearPage: () => {
        set({ page: null })
      },
    }
  },
  false,
)
